(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['skins.core.GooglePlusOneSkin'] = {
  "react": [
    [
      "div",
      "googlePlus",
      [],
      {}
    ]
  ],
  "params": {
    "tdr": "URL"
  },
  "paramsDefaults": {
    "tdr": "BASE_THEME_DIRECTORY"
  },
  "css": {
    "%[data-state~=\"small_bubble\"]": "background:url([tdr]google-plus-small-bubble.png) no-repeat;",
    "%[data-state~=\"small_none\"]": "background:url([tdr]google-plus-small-none.png) no-repeat;",
    "%[data-state~=\"small_inline\"]": "background:url([tdr]google-plus-small-inline.png) no-repeat;",
    "%[data-state~=\"medium_bubble\"]": "background:url([tdr]google-plus-medium-bubble.png) no-repeat;",
    "%[data-state~=\"medium_none\"]": "background:url([tdr]google-plus-medium-none.png) no-repeat;",
    "%[data-state~=\"medium_inline\"]": "background:url([tdr]google-plus-medium-inline.png) no-repeat;",
    "%[data-state~=\"standard_bubble\"]": "background:url([tdr]google-plus-standard-bubble.png) no-repeat;",
    "%[data-state~=\"standard_none\"]": "background:url([tdr]google-plus-standard-none.png) no-repeat;",
    "%[data-state~=\"standard_inline\"]": "background:url([tdr]google-plus-standard-inline.png) no-repeat;",
    "%[data-state~=\"tall_bubble\"]": "background:url([tdr]google-plus-tall-bubble.png) no-repeat;",
    "%[data-state~=\"tall_none\"]": "background:url([tdr]google-plus-tall-none.png) no-repeat;",
    "%[data-state~=\"tall_inline\"]": "background:url([tdr]google-plus-tall-inline.png) no-repeat;"
  }
}

        return skins;
    }));